<template>
  <div class="login_dialog_box">
    <div class="dialog_box">
      <div class="close_box"><IconClose @click.native="$emit('clickClose')" /></div>
      <div class="tip_info"><em class="icon_close" />下载次数已满</div>
      <div class="desc">当前下载次数已达上限，升级会员解锁无限下载</div>
      <div class="unlock_btn" @click="$emit('clickUnlock')">立即解锁</div>
    </div>
  </div>
</template>

<script>
import IconClose from '@/components/Icons/IconClose.vue'

export default {
  name: 'DownloadLimitDialog',

  components: { IconClose }

}
</script>

<style lang="scss" scoped>
.login_dialog_box { position: fixed; top: 0; left: 0; z-index: 14; width: 100%; height: 100%; text-align: center; background-color: rgba(0, 0, 0, 0.4);
  .dialog_box { position: absolute; top: 0; right: 0; bottom: 0; left: 0; width: 400px; height: 220px; margin: auto; background-color: #fff; border-radius: 8px; }
  .close_box { box-sizing: border-box; height: 30px; padding: 10px; overflow: hidden; font-size: 0; text-align: right; }
  .tip_info { display: inline-block; font-size: 20px; color: #3D6BFF; text-align: center;  }
  .icon_close { display: inline-block; width: 20px; height: 20px; margin-right: 16px; vertical-align: middle; background-image: url(~@/assets/images/icon_toast_error.png); background-size: cover; }
  .desc { margin: 46px 0 40px; font-size: 14px; font-weight: bold; }
  .unlock_btn { width: 90px; height: 32px; margin: 0 auto; font-size: 14px; font-weight: bold; line-height: 32px; color: #fff; text-align: center; cursor: pointer; background: #3D6BFF; border-radius: 8px; transition: background .4s;
    &:hover { background: #3461f3 }
  }
}
</style>
